<template>
    <main>
        <div class="container-fluid">
            <div class="mainButton">
                <div class="row">
                    <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <!-- <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-end">
                        <DownloadAction v-if="downloadAction" ref="loaddownload"></DownloadAction>
                    </div> -->
                </div>
            </div>
            <div class="page-toolbar">
                <div class="page-title">
                    <span class="title">Details for Intent to submit</span> 
                    <span class="star"> <i class="fa-solid fa-star"></i></span>
                </div>
            </div>
        </div>

        <GenericDetail v-if="generic" ref="loadGeneric"></GenericDetail>
        <CustomDetail v-else></CustomDetail>

        <template v-if="btnShowHide">
            <GenericMoreButton v-if="genericBtn" ref="loadgenericbtn"></GenericMoreButton>
            <CustomMoreButton v-else></CustomMoreButton>
        </template>

    </main>
       

</template>

<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/ExpressionInterests/MenuList.vue";
import lang from "@/views/modules/ExpressionInterests/language/en";
import GenericDetail from "@/components/layout/shared/generic/DetailView.vue";
import CustomDetail from "@/views/modules/ExpressionInterests/DetailView.vue";
import GenericMoreButton from "@/components/layout/shared/generic/common/MoreButton.vue";
import CustomMoreButton from "@/views/modules/ExpressionInterests/MoreButton.vue";
import DownloadAction from "@/components/layout/shared/generic/download/Download.vue";

export default {
name: "detail-Intent-To-Submit",
components: {
        breadcrumbs,
        GenericDetail,
        CustomDetail,
        CustomMoreButton,
        GenericMoreButton,
        DownloadAction,
    },
    data(){
        return{
            generic: false,
            genericBtn:false,
            btnShowHide:false,
            lang:[],
            metaList:[
                {
                    name:'col1',
                    items:[
                        {
                            name:'name',
                            label: lang.LBL_TAXTYPE_NAME,
                            link:false,
                            routePath:'',
                            is_image:false,
                        },
                        {
                            name:'tax',
                            label: lang.LBL_TAX_PERCENTAGE,
                            link:false,
                            routePath:'taxtypes'
                        },
                        {
                            name:'status',
                            label: lang.LBL_STATUS,
                            link:false,
                            routePath:''
                        },
                    ]   
                },
                       
               
              
                {
                    name:'col2',
                    items:[
                        {
                            name:'description',
                            label: lang.LBL_DESCRIPTION,
                            link:false,
                            routePath:''
                        },
                        {
                            name:'created_at',
                            label: lang.LBL_CREATED_DATE,
                            link:false,
                            routePath:''
                        },
                        {
                            name:'updated_at',
                            label: lang.LBL_MODIFIED_DATE,
                            link:false,
                            routePath:''
                        },
                    ]
                }
                        
               
                 
                               
            ],
            moreBtn:[
                {
                    id:'edit',
                    path:'taxtypes',
                    label: lang.LBL_ACTION_EDIT,
                    action:'edit',
                },
                {
                    id:'delete',
                    path:'taxtypes',
                    label: lang.LBL_ACTION_DELETE,
                    action:'delete',
                },
            ],
            routePath:{
                path:'taxtypes',
                detail:false
            },
            downloadAction:false,
            dowlloadList:[
                {
                    label: lang.LBL_DOWNLOAD_ONE,
                    action:"",
                    module:"",
                },
                {
                    label: lang.LBL_DOWNLOAD_TWO,
                    action:"",
                    module:"",
                }
            ]
        }
    },
    mounted() {
        this.childMethod();
        this.lang = lang;
        this.showdowmload();
    },
    methods:{
       childMethod(){
            if(this.generic == true){
                this.$refs.loadGeneric.loadGenericView(this.metaList,this.routePath);
            }
            if(this.genericBtn == true){
                this.$refs.loadgenericbtn.loadGenericBtn(this.moreBtn);
            }
        },
        showdowmload(){
            const self = this;
           
            if(self.downloadAction == true){
                this.$refs.loaddownload.loadDownloadView(self.dowlloadList);
            }
        }
    }
}

</script>



